import styled, { keyframes } from "styled-components"

const fade_in = keyframes`
0% {opacity: 0; transform: translateY(10px)}
100% {opacity: 1; transform: translateY(0)}
`

const pulse = keyframes`
0%, 100% { opacity: 1; }
50% { opacity: 0.6; }
`

export const QuizWrapp = styled.div`
  background: #f7f5f0;
  min-height: 100vh;
  
  .quiz {
    padding-top: 64px;
    display: flex;
    justify-content: center;

    .content {
      margin: 64px 0;
      width: 100%;
      max-width: 760px;
      padding: 0;
      animation: ${fade_in} 0.4s ease-out;
    }

    .progress-indicator {
      text-align: left;
      margin-bottom: 18px;
      
      span {
        background: #ebe6db;
        color: #4b5e50;
        padding: 6px 10px;
        border-radius: 8px;
        font-size: 12px;
        font-weight: 700;
      }
    }

    .analyzing-text {
      text-align: center;
      color: #5f6670;
      font-size: 14px;
      margin-bottom: 16px;
      animation: ${pulse} 1.5s ease-in-out infinite;
    }

    .recommend {
      background: #fbfaf7;
      border: 1px solid #e7e2d8;
      border-radius: 8px;
      padding: 32px;
      box-shadow: none;
      
      .result-header {
        text-align: left;
        margin-bottom: 24px;
        
        h2 {
          font-size: 2.4rem;
          color: #17201b;
          margin: 0;
          letter-spacing: 0;
        }
      }
      
      .result-card {
        .subtitle {
          font-size: 14px;
          color: #69716b;
          text-align: left;
          margin-bottom: 8px;
        }
        
        .rec_role {
          font-size: 2.8rem;
          color: #28342f;
          text-align: left;
          margin: 0 0 18px 0;
          font-weight: 700;
          line-height: 1.16;
        }
        
        .description {
          font-size: 14px;
          color: #4d5550;
          line-height: 1.6;
          text-align: left;
          margin-bottom: 22px;
          padding: 0;
        }
        
        .why-section, .growth-section, .salary-section {
          background: #f3f0e8;
          border: 1px solid #e7e2d8;
          border-radius: 8px;
          padding: 16px;
          margin-bottom: 14px;
          
          h4 {
            font-size: 14px;
            color: #28342f;
            margin: 0 0 8px 0;
          }
          
          p {
            font-size: 13px;
            color: #4d5550;
            margin: 0;
            line-height: 1.5;
          }
        }
        
        .salary-section {
          background: #edf2ec;
          border-color: #dbe5d9;
          
          .salary {
            font-size: 15px;
            font-weight: 600;
            color: #4b5e50;
          }
        }
        
        .skills-section {
          margin: 22px 0;
          
          h4 {
            font-size: 14px;
            color: #28342f;
            margin: 0 0 12px 0;
          }
          
          .skills-list {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            
            .skill-tag {
              background: #ebe6db;
              color: #4b5e50;
              padding: 6px 10px;
              border-radius: 8px;
              font-size: 12px;
              font-weight: 700;
            }
          }
        }
        
        .learning-path {
          background: #f3f0e8;
          border: 1px solid #e7e2d8;
          border-radius: 8px;
          padding: 16px;
          margin-bottom: 14px;
          
          h4 {
            font-size: 14px;
            color: #28342f;
            margin: 0 0 12px 0;
          }
          
          ol {
            margin: 0;
            padding-left: 20px;
            
            li {
              font-size: 13px;
              color: #4d5550;
              margin-bottom: 7px;
              line-height: 1.5;
            }
          }
        }
      }
      
      .action-buttons {
        display: flex;
        gap: 10px;
        justify-content: flex-start;
        margin-top: 24px;
        flex-wrap: wrap;
        
        .btn-rec {
          padding: 12px 18px;
          font-size: 14px;
          font-weight: 600;
          border-radius: 8px;
          border: none;
          cursor: pointer;
          transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
          
          &.primary {
            background: #28342f;
            color: white;
            
            &:hover {
              transform: translateY(-1px);
              background: #5f7967;
            }
          }
          
          &.secondary {
            background: transparent;
            color: #28342f;
            border: 1px solid #cfc8bb;
            
            &:hover {
              border-color: #5f7967;
            }
          }
        }
      }
    }

    .question {
      text-align: left;
      margin-bottom: 28px;
      font-size: 2.6rem;
      color: #17201b;
      font-weight: 600;
      line-height: 1.25;
      letter-spacing: 0;
    }

    .spin-load {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px;
      
      .center {
        margin: auto;
      }
    }

    .answers {
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
      }
      
      .answer {
        display: flex;
        align-items: center;
        gap: 14px;
        cursor: pointer;
        padding: 16px 18px;
        width: 100%;
        background: #fbfaf7;
        box-shadow: none;
        border-radius: 8px;
        margin-bottom: 10px;
        transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
        font-size: 14px;
        color: #28342f;
        border: 1px solid #e7e2d8;
        
        .answer-number {
          width: 28px;
          height: 28px;
          background: #ebe6db;
          color: #4b5e50;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 12px;
          flex-shrink: 0;
        }
        
        &:hover {
          transform: translateY(-1px);
          background: #fff;
          border-color: #b9c7b5;
        }
        
        &:active {
          transform: translateY(0);
        }
      }
    }

    .result {
      margin-top: 28px;
      display: flex;
      justify-content: flex-start;
      
      .btn-result {
        font-size: 14px;
        font-weight: 600;
        border-radius: 8px;
        border: none;
        cursor: pointer;
        padding: 12px 22px;
        background: #28342f;
        color: white;
        box-shadow: none;
        transition: background 0.2s ease, transform 0.2s ease;
        
        &:hover {
          transform: translateY(-1px);
          background: #5f7967;
        }
      }
    }
  }
  
  @media (max-width: 768px) {
    .quiz {
      .content {
        margin: 42px 0;
      }
      
      .question {
        font-size: 2.2rem;
      }
      
      .recommend {
        padding: 22px 18px;
        
        .result-card {
          .rec_role {
            font-size: 2.3rem;
          }
        }
        
        .action-buttons {
          flex-direction: column;
          
          .btn-rec {
            width: 100%;
          }
        }
      }
      
      .answers .answer {
        padding: 14px;
        font-size: 13px;
      }
    }
  }
`
